module.exports = __webpack_public_path__ + "static/media/cms_logo.fae643d7.jpg";